"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFontFamilyStyleProperties = exports.getFontFamilyCssProperties = exports.getFontFamily = void 0;
const platform_1 = require("../common/platform");
var FontTypes;
(function (FontTypes) {
    FontTypes["Medium"] = "Rubik-Medium";
    FontTypes["Regular"] = "Rubik-Regular";
    FontTypes["Default"] = "Rubik";
})(FontTypes || (FontTypes = {}));
var FontWeightValues;
(function (FontWeightValues) {
    FontWeightValues[FontWeightValues["Medium"] = 500] = "Medium";
    FontWeightValues[FontWeightValues["Regular"] = 400] = "Regular";
})(FontWeightValues || (FontWeightValues = {}));
var WeightTypes;
(function (WeightTypes) {
    WeightTypes["Regular"] = "regular";
    WeightTypes["Medium"] = "medium";
    WeightTypes["Inherit"] = "inherit";
})(WeightTypes || (WeightTypes = {}));
const getFontFamily = (weight) => {
    if ((0, platform_1.isAndroid)()) {
        switch (weight) {
            case WeightTypes.Medium:
                return FontTypes.Medium;
            case WeightTypes.Regular:
            default:
                return FontTypes.Regular;
        }
    }
    return FontTypes.Default;
};
exports.getFontFamily = getFontFamily;
const getFontFamilyCssProperties = (weight) => {
    const fontFamily = (0, exports.getFontFamily)(weight);
    if ((0, platform_1.isAndroid)()) {
        return `
      font-family: ${fontFamily};
    `;
    }
    switch (weight) {
        case WeightTypes.Medium:
            return `
        font-family: ${fontFamily};
        font-weight: ${FontWeightValues.Medium};
      `;
        case WeightTypes.Regular:
            return `
        font-family: ${fontFamily};
        font-weight: ${FontWeightValues.Regular};
      `;
        default:
        case WeightTypes.Inherit:
            return `
        font-family: ${fontFamily};
      `;
    }
};
exports.getFontFamilyCssProperties = getFontFamilyCssProperties;
const getFontFamilyStyleProperties = (weight) => {
    const fontFamily = (0, exports.getFontFamily)(weight);
    if ((0, platform_1.isAndroid)()) {
        return {
            fontFamily,
        };
    }
    switch (weight) {
        case WeightTypes.Medium:
            return {
                fontFamily,
                fontWeight: FontWeightValues.Medium,
            };
        case WeightTypes.Regular:
            return {
                fontFamily,
                fontWeight: FontWeightValues.Regular,
            };
        default:
        case WeightTypes.Inherit:
            return {
                fontFamily,
            };
    }
};
exports.getFontFamilyStyleProperties = getFontFamilyStyleProperties;
const exportedFunctions = {
    getFontFamilyCssProperties: exports.getFontFamilyCssProperties,
    getFontFamilyStyleProperties: exports.getFontFamilyStyleProperties,
};
exports.default = exportedFunctions;
